define([
    'text!product-detail/gallery/maintain-info.html',
    'product-detail/mixin/product',

    'css!product-detail/gallery/maintain-info.css'
], function(
    tpl,
    ProductMixin
){
    return {
        template: tpl,
        mixins: [ProductMixin],
        computed: {
            maintainText: function(){
                return this.spuExtraBase.maintainText || '';
            },
            isRender: function(){
                return this.moduleConfig.maintain && this.maintainText;
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/gallery/maintain-info.js
// module id = 326
// module chunks = 0